import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export interface PogHistoryEntry {
  pog: PogNonCircular;
  isApplySnaking: boolean;
}

export interface PogHistoryTransition {
  pog: PogNonCircular;
  history: PogHistoryEntry[];
  redoHistory: PogHistoryEntry[];
  shouldReinferSnaking: boolean;
}

export const getUndoPogHistoryTransition = (
  history: PogHistoryEntry[],
  redoHistory: PogHistoryEntry[],
): PogHistoryTransition | null => {
  if (history.length < 2) return null;

  const currentEntry = history[history.length - 1];
  const previousEntry = history[history.length - 2];

  return {
    pog: previousEntry.pog,
    history: history.slice(0, -1),
    redoHistory: [...redoHistory, currentEntry],
    shouldReinferSnaking: currentEntry.isApplySnaking,
  };
};

export const getRedoPogHistoryTransition = (
  history: PogHistoryEntry[],
  redoHistory: PogHistoryEntry[],
): PogHistoryTransition | null => {
  if (redoHistory.length === 0) return null;

  const nextEntry = redoHistory[redoHistory.length - 1];

  return {
    pog: nextEntry.pog,
    history: [...history, nextEntry],
    redoHistory: redoHistory.slice(0, -1),
    shouldReinferSnaking: nextEntry.isApplySnaking,
  };
};
